import { post } from '../components/Auths/AuthToken';
import setUiMessage from './Tostify';

const uploadfiles = async (apiurl, filedataobj) => {
  if (filedataobj) {
    try {
      const data = new FormData();
      data.append('file', filedataobj);

      const response = await post(apiurl, data, true);
      if (response?.status === 200) {
        return response;
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  } else {
    setUiMessage('err', 'Please select file');
  }
};

export default uploadfiles;
